import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define ProfileSettings interface
interface ProfileSettingsState {
    id: number;
    clientId: number;
    attributeName: string;
    value: string;
    version: number;
    notificationStatus?: 'Alert'; 
}

// Initial state
const initialState: ProfileSettingsState = {
    id: 0,
    clientId: 0,
    attributeName: '',
    value: '',
    version: 0,
    notificationStatus: 'Alert',
};

// Create Redux slice
const profileSettingsSlice = createSlice({
    name: 'profileSettings',
    initialState,
    reducers: {
        setProfileSettings: (state, action: PayloadAction<Partial<ProfileSettingsState>>) => {
            return { ...state, ...action.payload };
        },
        resetProfileSettings: () => initialState,
    },
});

// Export actions and reducer
export const { setProfileSettings, resetProfileSettings } = profileSettingsSlice.actions;
export default profileSettingsSlice.reducer;
